"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const CopaM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 16 16" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("g", { transform: "translate(9696 5733)" },
                react_1.default.createElement("path", { fillRule: "evenodd", d: "M12.68 6.541H12.34a13.566 13.566 0 00.6-4.4v-.395a2.11 2.11 0 012.04 2.382 2.175 2.175 0 01-2.3 2.414m-.765-4.415c-.043 4.595-1.031 6.2-3.889 6.257h-.162c-3.008 0-4.03-1.619-4.053-6.412v-.863h8.1v1.018m-1.462 12.962h-4.9c.15-1.332.94-1.958 2.448-1.958s2.3.626 2.45 1.958M3.322 6.541a2.172 2.172 0 01-2.3-2.411 2.092 2.092 0 011.77-2.347v.2A13.838 13.838 0 003.4 6.539h-.075M12.94.735v-.13A.508.508 0 0012.43.1H3.3a.508.508 0 00-.51.505v.158A3.078 3.078 0 000 4.13a3.154 3.154 0 003.306 3.422h.278c.075 0 .18-.007.291-.018a4.158 4.158 0 003.614 1.849v2.773A3.076 3.076 0 004.5 15.595a.509.509 0 00.512.505h5.972a.508.508 0 00.51-.505 3.077 3.077 0 00-2.987-3.438V9.372A4.025 4.025 0 0011.879 7.5l.109.02a4.016 4.016 0 00.417.032H12.689A3.155 3.155 0 0016 4.13 3.1 3.1 0 0012.94.735", transform: "translate(-9696 -5733.1)" })))));
};
exports.default = CopaM;
//# sourceMappingURL=index.js.map